import { useModalContext } from 'utils/contexts/modal';
import { InsertSnippetModal } from 'modules/snippets/components/modals/InsertSnippetModal';
import { SNIPPET_MODAL_ID } from './constants';
import { useInsertSnippet } from './hooks/useInsertSnippet';

export const SnippetModal = () => {
  const { hideModal, modalState } = useModalContext();
  const insertSnippet = useInsertSnippet();

  if (modalState !== SNIPPET_MODAL_ID) return <></>;

  return (
    <InsertSnippetModal
      closeModal={hideModal}
      onInsertSnippet={insertSnippet}
      data-portal-id="insert-snippet-modal"
    />
  );
};
